import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SessionsService } from '../services/sessions.service';

export async function buildSessionHeaders(sessionsService: SessionsService): Promise<Record<string, string>> {
  const activeSession = await sessionsService.getActiveSession();
  const sessionHeaders = { ...(activeSession.accessCredentials?.httpHeaders ?? {}) } as Record<string, string>;

  const idToken = sessionHeaders['X-Id-Token'];
  if (!sessionHeaders['Authorization'] && idToken) {
    sessionHeaders['Authorization'] = `Bearer ${idToken}`;
  }

  return sessionHeaders;
}

export function sessionInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const sessionsService = inject(SessionsService);
  const promise = buildSessionHeaders(sessionsService)
    .then((sessionHeaders) => {
      let headers = req.headers;
      Object.entries(sessionHeaders).forEach(([key, value]) => {
        headers = headers.set(key, value);
      });

      return req.clone({ headers, withCredentials: true });
    })
    .catch(() => {
      console.log({
        message: 'No active session, waiting user action',
      });
      return req.clone({ withCredentials: true });
    });
  return from(promise).pipe(switchMap((request) => next(request)));
}
